import React from "react";

/**
 * SectionHeader — minimal, clean section title block.
 * Kicker/num are optional — omit them for a cleaner premium feel.
 */
export default function SectionHeader({ kicker, num, title, subtitle, align = "left", as: Tag = "h2" }) {
  const rootAlign = align === "center" ? "text-center mx-auto" : "";
  return (
    <div className={`mb-12 md:mb-16 max-w-3xl ${rootAlign}`}>
      <Tag className="h-display text-4xl sm:text-5xl md:text-6xl text-white mb-5">{title}</Tag>
      {subtitle && (
        <p className="text-base md:text-lg text-zinc-400 leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}
